module.exports = __webpack_public_path__ + "img/logo.25348f12.png";